import { render, staticRenderFns } from "./SendedNew.vue?vue&type=template&id=66801411"
import script from "./SendedNew.vue?vue&type=script&lang=js"
export * from "./SendedNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports